(function ($, Drupal, once) {
  'use strict';

  // Main menu first level dropdowns
  if ($('body').hasClass('homes-theme')) {
    $('.menu-item .main-nav-search').closest('.main-menu').addClass('with-search');

    $('button.main-menu-top-btn, .sub-item-dropdown-wrapper button:not(.btn-sub-menu-trigger)').each(function () {
      $(this).attr('tabindex', '-1');
      $(this).addClass('menu-trigger');
    });
    $('.menu-item-dropdown .menu-item-dropdown-wrapper .menu-trigger').attr('aria-expanded', 'false');
    $('.menu-item-dropdown .menu-item-dropdown-wrapper .menu-trigger').on('click', function (e) {
      e.preventDefault();
      $('.sub-menu-wrap').css('min-height', '0');
      if ($(this).closest('.menu-item').hasClass('main-dropdown-open')) {
        $('.menu-item-dropdown').removeClass('main-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
      } else {
        $('.menu-item-dropdown').removeClass('main-dropdown-open');
        $('.menu-item-dropdown .menu-trigger').attr('aria-expanded', 'false');
        $(this).closest('.menu-item').addClass('main-dropdown-open');
        $('.main-dropdown-open .menu-trigger').attr('aria-expanded', 'true');
        var subMinHeight = $('.sub-dropdown-open .sub-sub-menu').outerHeight();
        $('.sub-menu-wrap').css('min-height', subMinHeight + 61 + 'px');
      }
    });
    $('.menu-item-dropdown.sub-item .menu-trigger').attr('aria-expanded', 'false');
    $('.menu-item-dropdown.sub-item .menu-trigger').on('click', function (e) {
      e.preventDefault();
      console.log('pressed');
      $('.sub-menu-wrap').css('min-height', '0');
      $('.sub-sub-menu').css('min-height', '0');
      if ($(this).parent().parent().hasClass('sub-dropdown-open')) {
        $('.menu-item-dropdown').removeClass('sub-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
      } else {
        $('body').addClass('sub-sub-open');
        $('.menu-item-dropdown').removeClass('sub-dropdown-open');
        $('.menu-item-dropdown .menu-trigger').attr('aria-expanded', 'false');
        $(this).parent().parent().addClass('sub-dropdown-open');
        $(this).attr('aria-expanded', 'true');
        var subMinHeight = $('.sub-dropdown-open .sub-sub-menu').outerHeight();
        var subSubMinHeight = $('.main-dropdown-open .sub-menu').outerHeight();
        $('.sub-menu-wrap').css('min-height', subMinHeight + 61 + 'px');
        $('.sub-dropdown-open .sub-sub-menu').css('min-height', subSubMinHeight - 72 + 'px');
      }
    });
    $('.btn-sub-sub-back').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.sub-item').removeClass('sub-dropdown-open');
      $('body').removeClass('sub-sub-open');
    });
  }

  Drupal.behaviors.ResponsiveConfirmationModal = {
    attach: function attach(context, settings) {

      $(window).on('dialog:aftercreate', function (event, ui) {
        var $visible = $('.ui-dialog:visible');
        // each open dialog
        $visible.each(function () {
          var $this = $(this);
          var dialog = $this.find('.ui-dialog-content');
          var wWidth = $(window).width();
          // check window width against dialog width
          if (wWidth < 650) {
            // keep dialog from filling entire screen
            $this.css('max-width', '90%');
          } else {
            // fix maxWidth bug
            $this.css('max-width', '650px');
          }

        });
      });

    },
  };

  $('.homes-search').on('click', function () {
    $('#block-viewsexposedfilterblock-3 #views-exposed-form-bgh-developments-block-2').css('display', 'flex');
  });

  Drupal.behaviors.ShareFunctionalityFallback = {
    attach: function attach(context, settings) {
      'use strict';

      $('.share-whatsapp-link').attr('href', function (index, value) {
        if (!value.startsWith('whatsapp:')){
          return 'whatsapp:' + value;
        }
      });

      $('.share-clipboard-link').on('click', function (event) {
        event.preventDefault();
        window.navigator.clipboard.writeText(window.location.href);
      });
    },
  };

})(jQuery, Drupal, once);
